import { Component, OnInit,Inject, ViewChild } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog'
import { HttpClient } from '@angular/common/http'
import {DashboardService} from './../../dashboard.service'
import { FormControl, FormGroup, NgForm } from '@angular/forms';

@Component({
    selector: 'app-edit-dialog',
    templateUrl: './edit-dialog.component.html',
    styleUrls: ['./edit-dialog.component.scss'],
    standalone: false
})
export class EditDialogComponent implements OnInit {

  @ViewChild('editForm') editForm:NgForm
  constructor(public dialogRef: MatDialogRef<EditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private dashboardService:DashboardService) { }

  ngOnInit(): void {
  }

  onSubmit(){
    this.dashboardService.updateTextOfAnswer({
      id:this.data._id,
      testId:this.data.testId,
      testQuestionId:this.data.questionId,
      text:this.editForm.value.text
    }).subscribe((response)=>{
      console.log(response)
      this.dialogRef.close()
    })
  }

  onNoClick(){
    this.dialogRef.close()
  }
}
